import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { editSelf2Factor, edit2Factor } from "actions/Users";
import { toastManager } from "components/ToastNotification";
import SelectInput from "components/SelectInput";
import ButtonContained from "components/ButtonContained";

const UserSettingsAuthenticationModal = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const authUser = useSelector(state => state.auth.authUser);
  const user = useSelector(state => state.users.userObject);
  const [use2FactorAuth, setUse2FactorAuth] = useState(false);
  const [methodFor2FactorAuth, setMethodFor2FactorAuth] = useState(null);

  useEffect(() => {
    if (user) {
      setUse2FactorAuth(user.use2FactorAuth);
      setMethodFor2FactorAuth(user.methodFor2FactorAuth);
    }
  }, [user]);

  const handleSave = () => {
    if (use2FactorAuth && methodFor2FactorAuth === "email" && user.email === "") {
      toastManager.addToast(intl.formatMessage({ id: "pages.authentication.warnEmail" }));
      return;
    }
    if (use2FactorAuth && methodFor2FactorAuth === "phone" && user.phone === "") {
      toastManager.addToast(intl.formatMessage({ id: "pages.authentication.warnPhone" }));
      return;
    }
    if (authUser.uuid !== user.uuid) {
      dispatch(edit2Factor(
        {
          userUUID: user.uuid,
          use2FactorAuth: use2FactorAuth,
          methodFor2FactorAuth: methodFor2FactorAuth
        },
        {
          successMessage: intl.formatMessage({ id: "notifications.success.edit" })
        }
      ));
    } else {
      dispatch(editSelf2Factor(
        {
          use2FactorAuth: use2FactorAuth,
          methodFor2FactorAuth: methodFor2FactorAuth
        },
        {
          successMessage: intl.formatMessage({ id: "notifications.success.edit" })
        }
      ));
    }
  }

  return (
    <div className="min-h-[300px] px-10 pt-4 flex flex-col justify-between">
      <div className="flex flex-col gap-4">
        <div>
          <h5 className="tw-heading-5 mb-4">{intl.formatMessage({ id: "comp.authentication.Header" })}</h5>
        </div>
        <SelectInput
          id="User-Settings-Authentication-Input"
          dataCy="User-Settings-Authentication-Input"
          value={use2FactorAuth}
          placeholder={intl.formatMessage({ id: "pages.authentication.Type" })}
          onChange={(e) => setUse2FactorAuth(e.target.value === "true")}
          options={[
            { name: intl.formatMessage({ id: "comp.form.yes" }), value: true },
            { name: intl.formatMessage({ id: "comp.form.no" }), value: false },
          ]}
        />
        {use2FactorAuth && <SelectInput
          id="User-Settings-Authentication-Type-Input"
          dataCy="User-Settings-Authentication-Type-Input"
          value={methodFor2FactorAuth}
          placeholder={intl.formatMessage({ id: "pages.authentication.Method" })}
          onChange={(e) => setMethodFor2FactorAuth(e.target.value)}
          options={[
            { name: intl.formatMessage({ id: "comp.table.header.email" }), value: "email" },
            { name: intl.formatMessage({ id: "comp.table.header.phone" }), value: "phone" },
          ]}
        />}
      </div>
      <div>
        <ButtonContained
          id="User-Settings-Authentication-Save-Changes-Button"
          dataCy="User-Settings-Authentication-Save-Changes-Button"
          text={intl.formatMessage({ id: "comp.button.saveChanges" })}
          type="medium"
          disabled={!user || !methodFor2FactorAuth || (use2FactorAuth === user?.use2FactorAuth && methodFor2FactorAuth === user?.methodFor2FactorAuth)}
          onClick={() => handleSave()}
        />
      </div>
    </div>
  )
};

export default UserSettingsAuthenticationModal;